import React from 'react';
import { ButtonGroup, ToggleButton } from 'react-bootstrap';
import { manufacturerConfig } from '../configs/manufacturerConfig';

const ManufacturerSwitcher = ({ selectedManufacturer, onManufacturerChange, manufacturerOrder = ['toyota', 'raymond-us', 'raymond-eu'] }) => {
	return (
		<ButtonGroup size="sm">
			{manufacturerOrder.map((manufacturer) => {
				const manufacturerConfigItem = manufacturerConfig[manufacturer];
				const isSelected = selectedManufacturer === manufacturer;
				
				return (
					<ToggleButton
						key={manufacturer}
						id={`manufacturer-${manufacturer}`}
						type="radio"
						variant={isSelected ? "primary" : "outline-secondary"}
						name="manufacturer"
						value={manufacturer}
						checked={isSelected}
						onChange={(e) => onManufacturerChange(e.currentTarget.value)}
						style={{
							backgroundColor: isSelected ? manufacturerConfigItem.color : 'transparent',
							borderColor: manufacturerConfigItem.color,
							color: isSelected ? 'white' : manufacturerConfigItem.color
						}}
						title={`Switch to ${manufacturerConfigItem.name}`}
					>
						{manufacturerConfigItem.name}
					</ToggleButton>
				);
			})}
		</ButtonGroup>
	);
};

export default ManufacturerSwitcher;
